import styled from 'styled-components';

export const IntentButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  background: none;
  outline: inherit;
  cursor: pointer;
  border: 1px solid rgba(223, 236, 234, 0.72);
  box-shadow: 0px 0px 1px rgba(110, 120, 129, 0.08), 0px 4px 4px rgba(153, 191, 188, 0.12);
  border-radius: ${props => props.theme.radii.small};

  width: 100%;
  height: 8.8rem;

  color: ${props => props.theme.colors.capsuleGreen60};

  margin-bottom: ${props => props.theme.space['3.6']};

  ${props => props.theme.mediaQueries.small} {
    margin-bottom: none;
  }

  &:hover {
    border: 1px solid rgba(223, 236, 234, 0.72);
    box-shadow: 0px 2px 6px rgba(110, 120, 129, 0.04), 0px 8px 16px rgba(153, 191, 188, 0.14);
  }

  &:active {
    background-color: ${props => props.theme.colors.capsuleGreen60};
    color: ${props => props.theme.colors.white};
  }

  &:first-of-type {
    margin-bottom: ${props => props.theme.space.s3};
  }
`;

export const TextContainer = styled.button`
  background: none;
  border: none;
  outline: inherit;
  cursor: pointer;
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.semiBold};
  font-size: ${props => props.theme.fontSizes.body};
  line-height: ${props => props.theme.lineHeights.body};
  color: inherit;

  ${props => props.theme.mediaQueries.smallDown} {
    margin: ${props => props.theme.space.s5} ${props => props.theme.space.s5};
  }
`;
